import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import { createBrowserHistory } from 'history'
import { ToastContainer } from 'react-toastify'
const AllRouter = React.lazy(() => import('./routes'))

// import AllRouter from './routes'

export const history = createBrowserHistory()

function App () {
  return (
    <>

      <BrowserRouter history={history}>
        <ToastContainer
          position="top-right"
        // autoClose={500000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
        <AllRouter/>
      </BrowserRouter>
    </>
  )
}

export default App
